import invariant from 'tiny-invariant';

const FONT_CONFIG = (() => {
  const json = document.getElementById('font-config')?.innerText;
  invariant(json, '#font-config not found');
  return JSON.parse(json);
})();

export const preloadedState = {
  fonts: FONT_CONFIG,
};
